import React, { useState, useEffect } from "react";
import "./index.css";
import { getAPIUrlBM } from "../../../utils/config";
import GET from "../../../Apis/backlink/Get";
import TipLoader from "../../utils/TipLoader/TipLoader";
import { useLocation } from "react-router-dom";
import {
  URLCleaning,
  datetime,
  getAllUserAccounts,
  getAllUserSites,
  makeUrlWithParams,
} from "./ActivityLogs";

const LinksActivity = ({ product }) => {
  const [activityLogs, setActivityLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allAccouts, setAllAccouts] = useState([]);
  const [allSites, setAllSites] = useState([]);
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(15);
  const [total, setTotal] = useState(0);
  const [sitesThatAreRelatedToAccount, setSitesThatAreRelatedToAccount] =
    useState([]);
  const [filter, setFilter] = useState({
    account: null,
    site: null,
    search: "",
  });

  const { state: getParams } = useLocation();

  console.log(getParams);

  useEffect(() => {
    if (getParams?.siteId || getParams?.accountId) {
      // setFilter({ ...filter, ...getParams });
      const { siteId, accountId } = getParams;
      if (accountId) {
        handleSitesFilterBasedOnAccount({ target: { value: accountId } });
      }
      if (siteId && accountId) {
        setFilter({ ...filter, site: siteId, account: accountId });
      } else if (siteId) {
        setFilter({ ...filter, site: siteId });
      } else if (accountId) {
        setFilter({ ...filter, account: accountId });
      }
    }
  }, [getParams]);

  const getActivityLogs = async () => {
    try {
      setLoading(true);
      const url = getAPIUrlBM();

      const urlWithParams = makeUrlWithParams(url + "/get-all-account-links", {
        accountId: filter.account,
        siteId: filter.site,
        search: filter.search,
        page,
      });
      // get-count-of-activity-logs
      const urkWithParamsForTotal = makeUrlWithParams(
        url + "/get-all-account-links-count",
        {
          accountId: filter.account,
          siteId: filter.site,
          search: filter.search,
        },
      );
      const responseForTotal = await GET(urkWithParamsForTotal);
      const response = await GET(urlWithParams);
      // const jsonData = await response;
      // console.log(jsonData);
      if (response.status === 200) {
        setActivityLogs(response.data);
      } else {
        setActivityLogs([]);
      }
      if (responseForTotal.status === 200) {
        setTotal(responseForTotal.data[0]?.count || 0);
      } else {
        setTotal(0);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      setActivityLogs([]);
      console.error(err.message);
    }
  };

  const getAccounts = async () => {
    try {
      const response = await getAllUserAccounts();
      if (response.status === 200) {
        setAllAccouts(response.data);
      } else {
        setAllAccouts([]);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleSitesFilterBasedOnAccount = (e) => {
    const selectedAccount = e.target.value;
    if (selectedAccount === "novalue") {
      setSitesThatAreRelatedToAccount([]);
      setPage(1);
      setFilter({ ...filter, account: null });
      return;
    }
    const sites = allSites.filter(
      (site) => site.account_id === selectedAccount,
    );
    setSitesThatAreRelatedToAccount(sites);
    setPage(1);
    setFilter({ ...filter, account: selectedAccount });
  };

  useEffect(() => {
    if (search === null) {
      return;
    }
    const totalTime = setTimeout(() => {
      setPage(1);
      setFilter({ ...filter, search: search });
    }, 1000);

    return () => clearTimeout(totalTime);
  }, [search]);

  const handleSiteFilter = (e) => {
    const selectedSite = e.target.value;
    if (selectedSite === "novalue") {
      setFilter({ ...filter, site: null });
      return;
    }
    setPage(1);
    setFilter({ ...filter, site: selectedSite });
  };
  const getSites = async () => {
    try {
      const response = await getAllUserSites(filter);
      if (response.status === 200) {
        setAllSites(response.data);
      } else {
        setAllSites([]);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    getAccounts();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      getActivityLogs();
      getSites();
    }, 500);
    return () => clearTimeout(timer);
  }, [page, filter]);

  return (
    <div className="activity-container">
      <div className="activity-header">
        <h1>Links Status</h1>
        <span
          className="reload-button"
          onClick={() => {
            getActivityLogs();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="16"
            className="icon"
            viewBox="0 0 512 512"
            fill="#6b7280"
          >
            <path d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z" />
          </svg>
          Refresh Logs
          <span className="ripple"></span>
        </span>
      </div>
      <div className="filter-content">
        <div className="filter-container">
          <h3>Filter & Search Backlinks</h3>
          <div className="activity-dropdown-items">
            <div className="activity-dropdown-item">
              <label htmlFor="select_account">Select account</label>
              <select
                id="select_account"
                onChange={handleSitesFilterBasedOnAccount}
                value={filter.account || "novalue"}
              >
                <option value="novalue">Select account</option>
                {allAccouts.map((account) => (
                  <option key={account.id} value={account.id}>
                    {account.searchconsoleemail}
                  </option>
                ))}
              </select>
            </div>
            <div className="activity-dropdown-item">
              <label htmlFor="select_site">Select site</label>
              <select
                id="select_site"
                onChange={handleSiteFilter}
                value={filter.site || "novalue"}
              >
                <option value="novalue">Select site</option>
                {sitesThatAreRelatedToAccount?.map((site) => (
                  <option key={site.id} value={site.id}>
                    {site.site_in_console}
                  </option>
                ))}{" "}
                {!sitesThatAreRelatedToAccount?.length &&
                  allSites?.map((site) => (
                    <option key={site.id} value={site.id}>
                      {site.site_in_console}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="search-container">
            <label htmlFor="search-element">Search</label>
            <input
              type="text"
              id="search-element"
              placeholder="Search a link"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="current_page" key={page + "numberofpageInshow"}>
        <div className="calculation">
          {
            <div className="calculation-text">
              Showing <span> {page * size - size + 1} </span> to{" "}
              <span> {page * size - size + activityLogs.length} </span> of{" "}
              <span> {total} </span> entries
            </div>
          }
        </div>
        <span
          className="current_page_left"
          onClick={() => {
            if (page > 1) {
              setPage(page - 1);
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="14"
            viewBox="0 0 448 512"
            fill={page === 1 ? "grey" : "white"}
          >
            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
          </svg>
        </span>
        <div className="current_page_number">{page}</div>
        <span
          className="current_page_right"
          onClick={() => {
            if (page < Math.ceil(total / size)) {
              setPage(page + 1);
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="14"
            viewBox="0 0 448 512"
            fill={page === Math.ceil(total / size) ? "grey" : "white"}
          >
            <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
          </svg>
        </span>
      </div>
      <div className="table-data">
        <table className="acti-table-container">
          <thead className="acti-thead">
            <tr>
              {/* <th className="acti-th"></th> */}
              <th className="acti-th">GSC Account</th>
              <th className="acti-th">GSC Site</th>
              <th className="acti-th acti-th-message" colSpan={3}>
                Link
              </th>
              {/* <th className="acti-th">Message</th> */}
              <th className="acti-th">Status</th>
              <th className="acti-th">Time ( in GMT )</th>
            </tr>
          </thead>
          {loading ? (
            <tbody>
              <tr>
                <td colSpan={7} className="no-data">
                  <TipLoader product={product} />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {activityLogs?.map((item) => (
                <tr key={item.id + "activityLogs"}>
                  <td className="acti-td">
                    <span className="account-name">
                      <span className="acti-tooltip">
                        {item.searchconsoleemail}
                      </span>
                      <span className="upperCaseName">
                        {item.searchconsoleemail
                          ? item.searchconsoleemail[0].toUpperCase()
                          : "-"}
                      </span>
                    </span>
                  </td>
                  <td className="acti-td acti-td-name">
                    <span className="site-name">
                      {item.site_in_console && (
                        <img
                          src={`https://www.google.com/s2/favicons?domain=${URLCleaning(
                            item.site_in_console,
                          )}`}
                          alt=""
                        />
                      )}
                      {URLCleaning(item.site_in_console)}
                    </span>
                  </td>
                  <td className="acti-td" colSpan={3}>
                    <span className="message">{item.url}</span>
                  </td>
                  <td className="acti-td">
                    <span className="acti-status message">
                      {item.indexingState}
                    </span>
                  </td>
                  <td className="acti-td">
                    {<span className="time">{datetime(item.create_date)}</span>}
                  </td>
                </tr>
              ))}
              {activityLogs.length === 0 && (
                <tr>
                  <td colSpan={7} className="no-data">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          )}{" "}
        </table>
      </div>
    </div>
  );
};

export default LinksActivity;
